import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {DayNote} from '@app/core/models/day-note.model';
import {Moment} from 'moment';
import {map} from 'rxjs/operators';

export interface IPatchPostDayNoteParams {
	hidden_note: boolean;
	note: string;
}

@Injectable()
export class DayNoteService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): DayNote {
		if (!params) {
			return new DayNote(this.tenantTZ, this.interService);
		}

		return new DayNote(this.tenantTZ, this.interService).deserialize(params);
	}

	public getDayNotes(startDate: Moment, endDate: Moment): Observable<DayNote[]> {
		return this.httpService.getJson<DayNote[]>('dayNotes', {
			start: startDate.format('YYYY-MM-DD'),
			end: endDate.format('YYYY-MM-DD'),
		}).pipe(map(res => res.map(d => this.fresh(d))));
	}

	public post(data: IPatchPostDayNoteParams): Observable<DayNote> {
		return new Observable<DayNote>((observer) => {
			this.subscriptions.push(this.httpService.postJson('dayNotes', data).subscribe((res: { success: boolean, day_note: {} }) => {
				observer.next(
					this.fresh(res.day_note),
				);
			}));
		});
	}

	public patch(dayNoteId: number, data: IPatchPostDayNoteParams): Observable<DayNote> {
		return this.httpService.patchJson<{ success: boolean, day_note: {} }>('dayNotes/' + dayNoteId, data).pipe(
			map(dayNote => this.fresh(dayNote))
		);
	}

	public delete(dayNoteId: number): Observable<void> {
		return this.httpService.deleteJson('dayNotes/' + dayNoteId);
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}
